import {
    useState,
    useEffect,
} from 'react';
import {
    Container,
    BoxSelect,
    BtnSearch,
    Content,
    Title
} from './styled';
import { Chart } from './Chart';
import { DatePicker, InputList } from '../../../../components';
import { IoIosSearch } from 'react-icons/io';
import moment from 'moment';
import { apiAdmin } from '../../../../service/api';
import { CgPerformance } from "react-icons/cg";


export function Performance() {

    const [dateStart, setDateStart] = useState(
        moment().subtract(6, 'months').format('YYYY-MM-DD')
    );
    const [dateEnd, setDateEnd] = useState(
        moment().format('YYYY-MM-DD')
    );
    const vision_type = [
        {
            id: 0,
            name: 'Total - Mensal',
            value: 'M',
        },
        {
            id: 1,
            name: 'Total - Semanal',
            value: 'W',
        }, {
            id: 2,
            name: 'Total - Diário',
            value: 'D',
        }
    ];
    const [visionTypeSelected, setVisionTypeSelected] = useState({
        id: 0,
        name: 'Total - Mensal',
        value: 'M',
    });
    const [dataCompany, setDataCompany] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showChart, setShowChart] = useState(false);


    const searchDataCompany = async (dateStart, dateEnd, type) => {
        try {
            setLoading(true);
            setDataCompany([]);
            const { data: { dados } } = await apiAdmin.post(`/atendimentos-visao?dt_ini=${dateStart}&dt_fim=${dateEnd}&tipo_visao=${type}`);
            setShowChart(true);
            setDataCompany(dados)
        } catch (error) {
            console.error(error);
        } finally {
            setShowChart(true);
            setLoading(false);
        }
    };
    useEffect(() => {
        searchDataCompany(
            moment(dateStart).format('DD/MM/YYYY'),
            moment(dateEnd).format('DD/MM/YYYY'),
            visionTypeSelected.value
        )
    }, []);
    useEffect(() => {
        setShowChart(false)
    }, [visionTypeSelected, dateEnd, dateStart])

    return (
        <Container>
            <BoxSelect>
                <div className='box--'>
                    <div className='line-'>
                        <DatePicker
                            className="date"
                            value={dateStart}
                            onChange={setDateStart}
                        />
                        <span> - </span>
                        <DatePicker
                            className="date"
                            value={dateEnd}
                            onChange={setDateEnd}
                        />
                    </div>
                    <div className='line-'>
                        <div className='list-'>
                            <InputList
                                options={vision_type}
                                value={visionTypeSelected?.name}
                                onChange={(e) => { setVisionTypeSelected(e) }}
                                toView={'name'}
                            />
                        </div>
                        <BtnSearch
                            disabled={loading ? 1 : 0}
                            onClick={() => {
                                searchDataCompany(
                                    moment(dateStart).format('DD/MM/YYYY'),
                                    moment(dateEnd).format('DD/MM/YYYY'),
                                    visionTypeSelected.value
                                )
                            }}
                        >
                            {loading
                                ? <span className='loader' />
                                : <IoIosSearch />
                            }
                        </BtnSearch>
                    </div>
                </div>
            </BoxSelect>
            <Content>
                <Title>
                    <span>
                        <CgPerformance fontSize={'3rem'} />
                    </span>
                    <div>
                        {`Total de atendimentos e clientes`}
                    </div>
                </Title>
                {(dataCompany?.length > 0 && showChart) &&
                    (<Chart
                        data={dataCompany}
                        visionType={visionTypeSelected.value}
                    />)
                }
            </Content>
        </Container >
    );
}
